import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class SubstituteUserService {
  constructor(private http: HttpClient) {}
}
